import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "range-input__input-group" };
const _hoisted_2 = ["id", "disabled", "required"];
const _hoisted_3 = { class: "range-input__divider" };
const _hoisted_4 = ["disabled", "required"];
import { ref, watch } from 'vue';
import log from "../../services/Logger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlRangeTime',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const TIME_PATTERN = /^(?:[0-1][0-9]|2[0-4]):[0-5][0-9](?::[0-5][0-9])?$/;
        const props = __props;
        const emit = __emit;
        const fieldOptions = props.field.options || {};
        const model = ref({ from: '00:00', to: '00:00' });
        const invalid = ref(false);
        init();
        watch(() => props.data, init);
        function init() {
            if (props.data) {
                model.value.from = props.data.from;
                model.value.to = props.data.to;
            }
        }
        function validate() {
            let error = false;
            if (model.value.from && !model.value.from.match(TIME_PATTERN)) {
                error = true;
            }
            if (model.value.to && !model.value.to.match(TIME_PATTERN)) {
                error = true;
            }
            if (!error && model.value.from && model.value.to) {
                const fromInt = parseInt(model.value.from.replace(':', ''));
                const toInt = parseInt(model.value.to.replace(':', ''));
                if (fromInt > toInt) {
                    error = true;
                }
            }
            invalid.value = error;
        }
        function onChange() {
            validate();
            if (invalid.value) {
                return;
            }
            log('FieldControlRangeTime@change', props.field.name, model.value);
            emit('change', model.value);
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form__control range-input", { 'form__control--invalid': invalid.value }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model.value.from) = $event)),
                        ref: "fromInput",
                        id: __props.fieldId,
                        disabled: _unref(fieldOptions).disabled ?? undefined,
                        required: _unref(fieldOptions).required ?? undefined,
                        step: "60",
                        type: "time",
                        class: "range-input__input",
                        placeholder: "00:00",
                        onChange: onChange,
                        onFocus: onFocus,
                        onBlur: onBlur
                    }, null, 40, _hoisted_2), [
                        [_vModelText, model.value.from]
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('range.to')), 1),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((model.value.to) = $event)),
                        ref: "toInput",
                        disabled: _unref(fieldOptions).disabled ?? undefined,
                        required: _unref(fieldOptions).required ?? undefined,
                        min: "00:00",
                        max: "24:00",
                        step: "60",
                        type: "time",
                        class: "range-input__input",
                        placeholder: "00:00",
                        onChange: onChange,
                        onFocus: onFocus,
                        onBlur: onBlur
                    }, null, 40, _hoisted_4), [
                        [_vModelText, model.value.to]
                    ])
                ])
            ], 2));
        };
    }
});
